module.exports = __webpack_public_path__ + "static/media/FUSE.db1e12ce.svg";